@use "sass:string";
@use "../../styles/breakpoint.module.scss" as *;

.inset {
    // unfortunately flexihero doesn't have a concept of column offsets so this
    // simulates that. Since the columns are a 50/50 split it doesn't break
    // anything visually.
    padding-inline: calc(
        var(--labui-grid-column-width) + var(--labui-grid-gap)
    );
}

.contentRight {
    padding-left: var(--spacer-48);
}

.contentLeft {
    padding-right: var(--spacer-48);
}

:export {
    sizes: string.unquote("(min-width: #{$mobile}) 40vw, 100vw");
}
